import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_AVG_CASES_PER_ACTIVE_DAY_QUERY_KEY } from "../types/CommonTypes";
import { GET_AVG_CASES_PER_ACTIVE_DAY_RESPONSE } from "../types/ResponseTypes";

async function getAvgCasesPerActiveDay(tenantId: string, hospitalId: string, queryString: string): Promise<GET_AVG_CASES_PER_ACTIVE_DAY_RESPONSE> {
  const baseUrl = "analytics/average-cases-per-active-day";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  
  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data?.otData || [];
}

export default function useGetAvgCasesPerActiveDayQuery(tenantId: string, hospitalId: string, queryString: string = "") {
  return useQuery({
    queryKey: [GET_AVG_CASES_PER_ACTIVE_DAY_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getAvgCasesPerActiveDay(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
} 